import { RiskLevelType } from "@/app/components/RiskIndicator/RiskIndicator";

type RiskCondition = {
  when: boolean;
  level: RiskLevelType;
};

export const getRiskLevel = (conditions: RiskCondition[]): RiskLevelType | null => {
  return conditions.find(condition => condition.when)?.level ?? null;
};
